// @flow
import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Toggle from 'react-toggled';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { withStyles } from '@material-ui/core/styles';
import { getText } from '../../utils/scribeUtils';
import EditProfileModal from './EditProfileModal';
import { getOS } from '../../utils';
import { withTranslation } from 'react-i18next';
import AvatarLogo from '../../components/Icons/AvatarLogo';

const styles = {
  lockerFinal: {
    position: 'absolute',
    left: '-30px',
  },
  transcript: {
    color: '#555555',
    marginBottom: '5px',
    lineHeight: 2,
  },
  transcriptWeb: {
    marginBottom: '5px',
  },
};

class FinalTranscript extends React.PureComponent<{
  currentPlatform: string,
  features: FeatureMap,
  fontSize: number,
  lang: string,
  speaker: Object,
  theme: Object,
  transcript: Transcript,
  user: Object,
  classes: Object,
  electronCaptionMode: boolean,
  t: Function,
}> {
  render() {
    const {
      currentPlatform,
      features,
      fontSize,
      lang,
      speaker,
      theme,
      transcript,
      user,
      classes,
      electronCaptionMode,
      t,
    } = this.props;

    if (!getText(transcript, lang)) {
      return null;
    }

    const isInternalAudio =
      speaker && speaker.id === user.avaId && transcript.trackName.startsWith('Ava Computer Audio');

    let color = theme.palette.error.light;
    if (speaker && speaker.theme) {
      const { theme: speakerTheme } = speaker;
      color = speakerTheme[`${theme.palette.type}_theme`].text_color;
    }

    if (speaker && (speaker.avaId === user.avaId || speaker.id === user.avaId)) {
      color =
        theme.palette.type === 'light'
          ? theme.palette.ava.navyGroup.convoText
          : theme.palette.ava.navyGroup.convoTextDark;

      if (isInternalAudio) {
        color = theme.palette.ava.green;
      }
    }

    if (theme.palette.type === 'dark' && color === '#000000') {
      color = '#FFFFFF';
    }

    let authorName = transcript.author;
    if (speaker && speaker.userName) {
      authorName = speaker.userName;
    }
    if (speaker && (speaker.avaId === user.avaId || speaker.id === user.avaId)) {
      authorName = t('transcripts.you');
      if (user.userName === 'web guest') {
        authorName += t('transcripts.tapToSetYourName');
      }
      if (isInternalAudio) {
        authorName = t('transcripts.internalAudioAuthorName');
      }
    }

    return (
      <>
        {currentPlatform === 'web' && (
          <div
            className={classes.transcriptWeb}
            style={{
              color: theme.palette.text.primary,
              lineHeight: `${fontSize}px`,
              fontSize: `${fontSize}px`,
              WebkitAppRegion: getOS() !== 'Mac' ? 'no-drag' : undefined,
            }}
          >
            <Grid
              container
              alignItems="center"
              wrap="nowrap"
              style={{
                marginTop:
                  transcript.authorShow && speaker && speaker.userAvatar !== '' && !isInternalAudio
                    ? `${fontSize / 5}`
                    : '0',
              }}
            >
              <Hidden xsDown>
                <Grid
                  item
                  xs="auto"
                  style={{
                    flexBasis: 0,
                    marginRight: !electronCaptionMode ? '5px' : 'initial',
                  }}
                >
                  {!electronCaptionMode && transcript.authorShow && speaker && speaker.userAvatar && !isInternalAudio && (
                    <Avatar
                      key="avatar"
                      src={speaker.userAvatar}
                      alt="speaker_photo"
                      style={{
                        width: fontSize,
                        height: fontSize,
                        marginTop: fontSize / 5,
                      }}
                    />
                  )}
                  {!electronCaptionMode &&
                    transcript.authorShow &&
                    speaker &&
                    !speaker.userAvatar &&
                    !isInternalAudio && <AvatarLogo color={color} width={fontSize * 2} height={fontSize * 2} />}
                </Grid>
              </Hidden>
              <Grid item xs css={{ lineHeight: 1 }}>
                {transcript.authorShow && (
                  <Toggle>
                    {({ on, getTogglerProps, setOff }) => (
                      <>
                        <Typography
                          variant="h5"
                          style={{
                            color: speaker
                              ? speaker.theme[`${theme.palette.type}_theme`].text_color
                              : theme.palette.error.light,
                            fontWeight: 'bold',
                            fontSize,
                            outline: 'none',
                            cursor: speaker && speaker.id === user.avaId && !isInternalAudio && 'pointer',
                          }}
                          {...getTogglerProps()}
                        >
                          <strong key="name">{authorName}</strong>
                        </Typography>
                        {speaker && speaker.id === user.avaId && !isInternalAudio && (
                          <EditProfileModal open={on} close={setOff} />
                        )}
                      </>
                    )}
                  </Toggle>
                )}
                <div
                  style={{
                    opacity: features['dev-mode'] ? 0.7 : 1,
                    // $FlowFixMe
                    fontWeight: transcript.highlighted ? 'bold' : '',
                  }}
                >
                  {getText(transcript, lang)}
                </div>
              </Grid>
            </Grid>
          </div>
        )}
      </>
    );
  }
}
export default withTranslation()(withStyles(styles)(FinalTranscript));
